import { create } from 'zustand';

import { ChannelMediaTypeEnum } from '@/features/broadcasters/types';
import { PaginationValues } from '@/hooks/usePagination';

type ProgramFiltersState = {
  state: 'active' | 'inactive' | '';
  priorities: number[];
  gte: string;
  lte: string;
  channel_id: string;
  channel_media_type: ChannelMediaTypeEnum | '';
  support: string;
  paginationValues: PaginationValues | null;
  setPaginationValues: (newPaginationValues: PaginationValues) => void;
  setFilters: (
    newFilters:
      | Partial<ProgramFiltersState>
      | ((prev: ProgramFiltersState) => Partial<ProgramFiltersState>)
  ) => void;
  resetFilters: () => void;
};

export const useProgramFilters = create<ProgramFiltersState>(set => ({
  state: '',
  priorities: [],
  gte: '',
  lte: '',
  channel_id: '',
  channel_media_type: '',
  support: '',
  paginationValues: null,
  setPaginationValues: newPaginationValues => set({ paginationValues: newPaginationValues }),
  setFilters: newFilters =>
    set(state => ({
      ...state,
      ...(typeof newFilters === 'function' ? newFilters(state) : newFilters),
    })),
  resetFilters: () =>
    set({
      state: '',
      priorities: [],
      gte: '',
      lte: '',
      channel_id: '',
      channel_media_type: '',
      support: '',
      paginationValues: null,
    }),
}));
